import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from '../../objects/user';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'gl-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnDestroy {
  public user: User;
  private userSub: Subscription;

  constructor(public userService: UserService) {
    this.userSub = userService.user.subscribe((user: User) => (this.user = user));
  }


  public ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }
}
